export default __webpack_public_path__ + "static/media/videosIcon.ec223b0c.svg";